import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bb0fe50")

_pushScopeId("data-v-4bb0fe50")
const _hoisted_1 = { class: "OrderTypes" }
const _hoisted_2 = { class: "OrderTypes__grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_order_type = _resolveComponent("order-type")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderTypes, (order_type) => {
        return (_openBlock(), _createBlock(_component_order_type, {
          key: order_type.id,
          type: order_type.type,
          title: order_type.title,
          hint: order_type.hint,
          "title-max-width": order_type.titleMaxWidth,
          disabled: order_type.disabled,
          img: order_type.img,
          "image-top": order_type.img_top,
          "image-bottom": order_type.img_bottom,
          "image-left": order_type.img_left,
          "image-right": order_type.img_right,
          "image-width": order_type.img_width,
          "image-height": order_type.img_height,
          onOpenLtl: _ctx.onOpenLtl,
          onOpenFtl: _ctx.onOpenFtl,
          onOpenExpress: _ctx.onOpenExpress,
          onOpenForm: _ctx.onOpenForm
        }, null, 8, ["type", "title", "hint", "title-max-width", "disabled", "img", "image-top", "image-bottom", "image-left", "image-right", "image-width", "image-height", "onOpenLtl", "onOpenFtl", "onOpenExpress", "onOpenForm"]))
      }), 128))
    ])
  ]))
})